<div class="citation-panel">
  <header class="citation-panel-header">
    <span class="citation-panel-title">{{ citation.label }}</span>
  </header>

  <div class="citation-panel-body">
    <div #previewHost class="citation-preview-host"></div>
    @if (!hasRichPreview) {
      <div class="citation-fallback">
        <mat-icon>visibility_off</mat-icon>
        <p>{{ 'This citation links to the underlying records rather than a preview. Open the full record below to view them.' | translate }}</p>
      </div>
    }
  </div>

  <footer class="citation-panel-footer">
    <a class="citation-open-full-record" [routerLink]="fullRecordPath" [queryParams]="fullRecordQueryParams">
      <mat-icon>open_in_new</mat-icon>
      {{ 'Open full record' | translate }}
    </a>
  </footer>
</div>
